import { SSE } from "~/host-app/processes/SSE"
import { CheckActiveUserSessions } from "~/host-app/processes/CheckActiveUserSessions"
import { ignoreKemsuWebSystem } from "~/shared/config"
import { isStandalone } from "~/shared/lib/utils"

import { SyncWithKemsuWebSystemSession } from "./SyncWithKemsuWebSystemSession"
import { TrackNewNotifications } from "./TrackNewNotifications"

export function Processes() {
	return (
		<>
			{!ignoreKemsuWebSystem && !isStandalone() && (
				<SyncWithKemsuWebSystemSession syncInterval={90000} />
			)}
			<TrackNewNotifications />
			<CheckActiveUserSessions/>
			<SSE/>
		</>
	)
}
